import React, { forwardRef } from 'react';

import { PKDTextInput } from './styles';

export const TextInput = forwardRef((props, ref) => {
  return (
    <PKDTextInput
      ref={ref} {...props} variant='outlined' error={props.error} data-testid='text-input'
    />
  );
});
